<template>
  <div class="extension-cropped">
    <div
      ref="body"
      class="extension-cropped__body"
      :style="{ maxHeight: maxHeight }"
    >
      <div class="extension-cropped__body-container">
        <slot />
      </div>
    </div>
    <div v-if="hasOverflow" class="extension-cropped__trigger">
      <dropdown-trigger
        :extended="extended"
        :label-extended="labelExtended"
        :label-shrunk="labelShrunk"
        :show-icon="showIcon"
        @click="toggleBody"
      />
    </div>
  </div>
</template>

<script>
import DropdownTrigger from "@/components/ui-kit/dropdown-trigger/index.vue";

export default {
  components: {
    DropdownTrigger,
  },
  props: {
    labelExtended: {
      type: String,
      default: undefined,
    },
    labelShrunk: {
      type: String,
      default: undefined,
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      extended: false,
      maxHeight: undefined,
      hasOverflow: false,
    };
  },
  mounted() {
    if (vueOptions.ssr) {
      return;
    }

    this.$nextTick(() => {
      this.checkOverflow();
      this.calculateMaxHeight();

      fakeWindow.addEventListener("load", this.calculateMaxHeight);
      fakeWindow.addEventListener("resize", this.calculateMaxHeight);
    });
  },
  beforeDestroy() {
    fakeWindow.removeEventListener("load", this.calculateMaxHeight);
    fakeWindow.removeEventListener("resize", this.calculateMaxHeight);
  },
  methods: {
    toggleBody() {
      this.extended = !this.extended;
      this.$emit("toggle", this.extended);
      this.calculateMaxHeight();
    },
    calculateMaxHeight() {
      if (this.extended) {
        this.maxHeight = `${this.$refs.body.scrollHeight}px`;
        return;
      }

      this.maxHeight = undefined;
      setTimeout(() => this.checkOverflow, 500);
    },
    checkOverflow() {
      if (!this.extended && this.$refs?.body) {
        this.hasOverflow =
          this.$refs.body.scrollHeight > this.$refs.body.offsetHeight;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.extension-cropped {
  &__body {
    overflow: hidden;
    transition: all 500ms ease-out;
    will-change: max-height;
    max-height: 260px;

    @include mixin.size-md-min {
      max-height: 260px;
    }

    &-container {
      @include mixin.font-regular();
      transition: none;

      >>> p {
        @include mixin.font-regular();
        padding: 0;

        &:not(:last-child) {
          margin-bottom: func.divide(22, 14) * 1em;
        }
      }
    }
  }

  &__trigger {
    margin-top: 16px;
  }
}
</style>
